export default __webpack_public_path__ + "static/SuisseIntl-UltraLight-5d9e85a521871e9748a7fc26bb68e445.woff2";